import React, { Component } from 'react';
import { connect } from 'react-redux';

import i18n from 'app/common/i18n';

import { setTitle } from 'app/layout/redux';
import DiscountDashboard from './dashboard';

@connect(({}) => ({}), { setTitle })
@i18n
class Discounts extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {
    this.props.setTitle(this.props.i18n('Discount Codes'));
  }

  render() {
    return <DiscountDashboard i18n={this.props.i18n} />;
  }
}

export default Discounts;
